'use strict';

import React from 'react';
import {Alert} from 'react-bootstrap';
import Cookies from 'js-cookie'
import InputField from './InputField.js'
import FaClose from 'react-icons/lib/fa/close'

function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.closeAndSubmit = this.closeAndSubmit.bind(this);
    this.submitDisabled = this.submitDisabled.bind(this);
    this.emptyFields = this.emptyFields.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleExtraChange = this.handleExtraChange.bind(this);
    this.handleSuccessDismiss = this.handleSuccessDismiss.bind(this);
    this.handleErrorDismiss = this.handleErrorDismiss.bind(this);
    this.classes = this.classes.bind(this);

    this.state = {
      showModal: false,
      name: '',
      email: '',
      phone: '',
      address: '',
      brand: '',
      model: '',
      year: '',
      color: '',
      transportation: false,
      service: 'lav',
      otherservice: '',
      wantotherservice: false,
      vehicletype: 'ligeiro',
      vehicletypeoptions: [{
        name: 'Mota',
        id: 'mota'
      },
        {
          name: 'Ligeiro',
          id: 'ligeiro'
        },
        {
          name: 'Monovolume',
          id: 'monovolume'
        },
        {
          name: 'SUV',
          id: 'suv'
        },
        {
          name: 'Jipe',
          id: 'jipe'
        },
        {
          name: 'Pesado',
          id: 'pesado'
        }],
      options: [{
        name: 'Lavagem Premium',
        id: 'lav'
      },
        {
          name: 'Detalhe Básico',
          id: 'det-basic'
        },
        {
          name: 'Detalhe Económico',
          id: 'det-econ'
        },
        {
          name: 'Detalhe Executivo',
          id: 'det-exec'
        },
        {
          name: 'Detalhe Premium',
          id: 'det-prem'
        }],
      availableExtra: [
        {selected: false, label: 'Descontaminação da Pintura', notIncluded: ['lav']},
        {selected: false, label: 'Polimento da Pintura (até 2 fases)', notIncluded: ['lav', 'det-basic']},
        {
          selected: false,
          label: 'Polimento da Pintura (até 3 fases)',
          notIncluded: ['lav', 'det-basic', 'det-econ', 'det-exec']
        },
        {selected: false, label: 'Selagem da Pintura (1 aplicação)', notIncluded: ['lav']},
        {selected: false, label: 'Selagem da Pintura (2 aplicações)', notIncluded: ['lav', 'det-basic']},
        {
          selected: false,
          label: 'Selagem e enceramento da Pintura (3 aplicações)',
          notIncluded: ['lav', 'det-basic', 'det-econ', 'det-exec']
        },
        {selected: false, label: 'Selagem do exterior das jantes', notIncluded: ['lav', 'det-basic']},
        {selected: false, label: 'Lavagem da cava das rodas', notIncluded: ['lav', 'det-basic', 'det-econ']},
        {
          selected: false,
          label: 'Lavagem e selagem das jantes completas',
          notIncluded: ['lav', 'det-basic', 'det-econ']
        },
        {selected: false, label: 'Lavagem e condicionamento do motor', notIncluded: ['lav']},
        {selected: false, label: 'Protecção dos vidros exteriores', notIncluded: ['lav', 'det-basic', 'det-econ']},
        {
          selected: false,
          label: 'Polimento e selagem das ópticas',
          notIncluded: ['lav', 'det-basic', 'det-econ', 'det-exec']
        },
        {selected: false, label: 'Lavagem de tapetes', notIncluded: ['lav']},
        {
          selected: false,
          label: 'Lavagem de tapetes e carpetes',
          notIncluded: ['lav', 'det-basic', 'det-econ', 'det-exec']
        },
        {
          selected: false,
          label: 'Limpeza de estofos em tecido e em pele',
          notIncluded: ['lav', 'det-basic', 'det-econ']
        },
        {selected: false, label: 'Hidratação das peles (2 aplicações)', notIncluded: ['lav', 'det-basic', 'det-econ']},
        {selected: false, label: 'Protecção dos tecidos (2 aplicações)', notIncluded: ['lav', 'det-basic', 'det-econ']},
      ],
      observations: '',
      successVisible: false,
      errorVisible: false
    }
  }

  submitDisabled() {
    return this.state.name.trim().length <= 1
      || !validateEmail(this.state.email.trim())
      || this.state.phone.trim().length <= 0
      || this.state.brand.trim().length <= 0
      || this.state.model.trim().length <= 0
      || this.state.year.trim().length <= 0
      || this.state.color.trim().length <= 0
  }

  emptyFields() {
    let res = [];
    if (this.state.name.trim().length <= 1) res.push('Nome');
    if (!validateEmail(this.state.email.trim())) res.push('Email');
    if (this.state.phone.trim().length <= 0) res.push('Telefone');
    if (this.state.brand.trim().length <= 0) res.push('Marca');
    if (this.state.model.trim().length <= 0) res.push('Modelo');
    if (this.state.year.trim().length <= 0) res.push('Ano');
    if (this.state.color.trim().length <= 0) res.push('Cor');
    return res;
  }

  handleSuccessDismiss() {
    this.setState({
      successVisible: false
    })
  }

  handleErrorDismiss() {
    this.setState({
      errorVisible: false
    })
  }

  clearForm() {
    this.setState({
      showModal: false,
      submitDisabled: true,
      name: '',
      email: '',
      phone: '',
      address: '',
      brand: '',
      model: '',
      year: '',
      color: '',
      transportation: false,
      service: 'lav',
      otherservice: '',
      wantotherservice: false,
      vehicletype: 'ligeiro',
      vehicletypeoptions: [{
        name: 'Mota',
        id: 'mota'
      },
        {
          name: 'Ligeiro',
          id: 'ligeiro'
        },
        {
          name: 'Monovolume',
          id: 'monovolume'
        },
        {
          name: 'SUV',
          id: 'suv'
        },
        {
          name: 'Jipe',
          id: 'jipe'
        },
        {
          name: 'Pesado',
          id: 'pesado'
        }],
      options: [{
        name: 'Lavagem Premium',
        id: 'lav'
      },
        {
          name: 'Detalhe Básico',
          id: 'det-basic'
        },
        {
          name: 'Detalhe Económico',
          id: 'det-econ'
        },
        {
          name: 'Detalhe Executivo',
          id: 'det-exec'
        },
        {
          name: 'Detalhe Premium',
          id: 'det-prem'
        }],
      availableExtra: [
        {selected: false, label: 'Descontaminação da Pintura', notIncluded: ['lav']},
        {selected: false, label: 'Polimento da Pintura (até 2 fases)', notIncluded: ['lav', 'det-basic']},
        {
          selected: false,
          label: 'Polimento da Pintura (até 3 fases)',
          notIncluded: ['lav', 'det-basic', 'det-econ', 'det-exec']
        },
        {selected: false, label: 'Selagem da Pintura (1 aplicação)', notIncluded: ['lav']},
        {selected: false, label: 'Selagem da Pintura (2 aplicações)', notIncluded: ['lav', 'det-basic']},
        {
          selected: false,
          label: 'Selagem e enceramento da Pintura (3 aplicações)',
          notIncluded: ['lav', 'det-basic', 'det-econ', 'det-exec']
        },
        {selected: false, label: 'Selagem do exterior das jantes', notIncluded: ['lav', 'det-basic']},
        {selected: false, label: 'Lavagem da cava das rodas', notIncluded: ['lav', 'det-basic', 'det-econ']},
        {
          selected: false,
          label: 'Lavagem e selagem das jantes completas',
          notIncluded: ['lav', 'det-basic', 'det-econ']
        },
        {selected: false, label: 'Lavagem e condicionamento do motor', notIncluded: ['lav']},
        {selected: false, label: 'Protecção dos vidros exteriores', notIncluded: ['lav', 'det-basic', 'det-econ']},
        {
          selected: false,
          label: 'Polimento e selagem das ópticas',
          notIncluded: ['lav', 'det-basic', 'det-econ', 'det-exec']
        },
        {selected: false, label: 'Lavagem de tapetes', notIncluded: ['lav']},
        {
          selected: false,
          label: 'Lavagem de tapetes e carpetes',
          notIncluded: ['lav', 'det-basic', 'det-econ', 'det-exec']
        },
        {
          selected: false,
          label: 'Limpeza de estofos em tecido e em pele',
          notIncluded: ['lav', 'det-basic', 'det-econ']
        },
        {selected: false, label: 'Hidratação das peles (2 aplicações)', notIncluded: ['lav', 'det-basic', 'det-econ']},
        {selected: false, label: 'Protecção dos tecidos (2 aplicações)', notIncluded: ['lav', 'det-basic', 'det-econ']},
      ],
      observations: '',
    })
  }

  // componentWillMount() {
  //   this.setState({ showModal: false });
  // }

  close() {
    this.setState({showModal: false});
  }

  closeAndSubmit() {
    this.setState({showModal: false});
    let self = this
    var getVehicleTypeName = function () {
      for (var i = 0; i < self.state.vehicletypeoptions.length; i++) {
        let option = self.state.vehicletypeoptions[i]
        if (option.id == self.state.vehicletype) {
          return option.name
        }
      }
      return '';
    }

    var getSelectedServiceName = function () {
      for (var i = 0; i < self.state.options.length; i++) {
        let option = self.state.options[i]
        if (option.id == self.state.service) {
          return option.name
        }
      }
      return '';
    }

    var getExtraServicesSelected = function () {
      let list = '<ul>'
      for (var i = 0; i < self.state.availableExtra.length; i++) {
        let option = self.state.availableExtra[i]
        if (option.selected && option.notIncluded.indexOf(self.state.service) >= 0) {
          list += `<li>${option.label}</li>`
        }
      }
      if (self.state.wantotherservice) {
        list += `<li><strong>Outro:</strong> ${self.state.otherservice}</li>`
      }
      list += '</ul>'
      return list
    }
    let message = `
<p><h3>Cliente</h3></p>
<p><strong>Nome:</strong> ${this.state.name}</p>
<p><strong>E-mail:</strong> ${this.state.email}</p>
<p><strong>Telefone:</strong> ${this.state.phone}</p>
<br/>
<p><h3>Serviço</h3></p>
<p><strong>Serviço de Recolha e Entrega?</strong> ${this.state.transportation ? 'Sim' : 'Não'}</p>
<p><strong>Morada:</strong> ${this.state.address}</p>
<p><strong>Pacote Selecionado:</strong> ${getSelectedServiceName()}</p>
<p><strong>Serviços Extra:</strong> ${getExtraServicesSelected()}</p>

<p><h3>Viatura</h3></p>
<p><strong>Tipo de Viatura:</strong> ${getVehicleTypeName()}</p>
<p><strong>Marca:</strong> ${this.state.brand}</p>
<p><strong>Modelo:</strong> ${this.state.model}</p>
<p><strong>Ano:</strong> ${this.state.year}</p>
<p><strong>Cor:</strong> ${this.state.color}</p>

<p><strong>Observações:</strong> ${this.state.observations}</p>
<br/>
<p><em>Mensagem Enviada pelo Site</em></p>
<p><em><a href="https://nhdetails.pt">NH Premium Details</a></em></p>
`
    //console.log(message)
    let csrftoken = Cookies.get('csrftoken');
    fetch('/api/v1/contact/', {
      method: 'POST',
      headers: {
        // 'Accept': 'application/json',
        // 'Content-Type': 'application/json',
        'X-CSRFToken': csrftoken
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        name: this.state.name,
        email: this.state.email,
        subject: `[${getSelectedServiceName()}|${getVehicleTypeName()}] Pedido de Orçamento de ${this.state.name}`,
        message: message
      })
    })
      .then(response => {
        if (response.ok) {
          this.setState({successVisible: true})
          setTimeout(function () {
            this.setState({
              successVisible: false
            });
          }.bind(this), 5000);
          this.clearForm();
        } else {
          this.setState({errorVisible: true})
          setTimeout(function () {
            this.setState({errorVisible: false});
          }.bind(this), 5000);
        }
      })
      .catch(() => {
        this.setState({errorVisible: true})
        setTimeout(function () {
          this.setState({errorVisible: false});
        }.bind(this), 5000);
      })
  }

  open() {
    this.setState({showModal: !this.state.showModal});
  }

  classes() {
    return `contact-form contact-form-complete ${this.state.showModal ? 'visible' : ''}`;
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    //console.log(`${name} -> ${target.type}`)
    if (target.type == 'checkbox') {
      this.setState({
        [name]: target.checked ? true : false
      });
    } else {
      this.setState({
        [name]: target.value
      });
    }
    //console.log(`${name} -> ${target.checked}`)
    //console.log(this.state)
  }

  handleExtraChange(event) {
    const target = event.target;
    const name = target.name;
    //console.log(`${name} -> ${target.type}`)
    if (target.type == 'checkbox') {
      let options = this.state.availableExtra
      //console.log(options)
      options[name].selected = target.checked ? true : false
      this.setState({
        ['availableExtra']: options
      });
    }
    //console.log(`${name} -> ${target.checked}`)
    //console.log(this.state)
  }

  render() {
    /*const popover = (
      <Popover id="modal-popover" title="popover">
        very popover. such engagement
      </Popover>
    );
    const tooltip = (
      <Tooltip id="modal-tooltip">
        wow.
      </Tooltip>
    );*/

    return (
      <div>
        <div className={this.classes()}>
          <button
            className="toggle-button big"
            onClick={this.open}>
            Pedir Orçamento
          </button>
          <div className="body">
            <button className="close-button" onClick={this.close}><FaClose/></button>
            <div className="site__form">
              <h2 className="title">Pedido de Orçamento</h2>
              <InputField name="name" value={this.state.name} onChange={this.handleInputChange} type="text" label="Nome"
                          errorMessage="Este campo é obrigatório"/>
              <InputField name="email" value={this.state.email} onChange={this.handleInputChange} type="email"
                          label="Email" errorMessage="Introduza um endereço de e-mail válido"/>
              <InputField name="phone" value={this.state.phone} onChange={this.handleInputChange} type="text"
                          label="Telefone" errorMessage="Este campo é obrigatório"/>

              <h3 className="title">Serviço</h3>
              <InputField name="transportation" value={this.state.transportation} onChange={this.handleInputChange}
                          type="checkbox" label="Deseja contratar o serviço de recolha e entrega da viatura?"
                          errorMessage=""/>
              {this.state.transportation &&
              <InputField name="address" value={this.state.address} onChange={this.handleInputChange} type="text"
                          label="Morada" errorMessage="Introduza a morada"/>
              }
              <InputField name="service" value={this.state.service} onChange={this.handleInputChange}
                          options={this.state.options} type="select" label="Serviço Pretendido:"/>
              {this.state.service != '' &&
              <div>
                <h3 className="title">Adicionar Serviços Extra</h3>
                {this.state.availableExtra.map((e, i) =>
                  <InputField key={i} name={i} hidden={e.notIncluded.indexOf(this.state.service) < 0} value={e.selected}
                              onChange={this.handleExtraChange} type="checkbox" label={e.label} errorMessage=""/>
                )}
                <InputField name="wantotherservice" value={this.state.wantotherservice}
                            onChange={this.handleInputChange} type="checkbox" label="Outro" errorMessage=""/>
                {this.state.wantotherservice &&
                <InputField name="otherservice" value={this.state.otherservice} onChange={this.handleInputChange}
                            type="text" label="Qual?" errorMessage="Introduza o serviço extra pretendido"/>
                }
              </div>
              }
              <h3 className="title">Dados da Viatura</h3>
              <InputField name="vehicletype" value={this.state.vehicletype} onChange={this.handleInputChange}
                          options={this.state.vehicletypeoptions} type="select" label="Tipo de viatura:"/>
              <div className="row">
                <InputField name="brand" value={this.state.brand} onChange={this.handleInputChange} type="text"
                            label="Marca" errorMessage="Este campo é obrigatório"/>
                <InputField name="model" value={this.state.model} onChange={this.handleInputChange} type="text"
                            label="Modelo" errorMessage="Este campo é obrigatório"/>
              </div>
              <div className="row">
                <InputField name="year" value={this.state.year} onChange={this.handleInputChange} type="text"
                            label="Ano" errorMessage="Este campo é obrigatório"/>
                <InputField name="color" value={this.state.color} onChange={this.handleInputChange} type="text"
                            label="Cor" errorMessage="Este campo é obrigatório"/>
              </div>
              <InputField name="observations" value={this.state.observations} onChange={this.handleInputChange}
                          type="area" rows="1" label="Observações" errorMessage=""/>
              <button disabled={this.submitDisabled()} onClick={this.closeAndSubmit}>Enviar Pedido de Orçamento</button>
              {this.submitDisabled() && (
                <div style={{color: '#fff', fontWeight: 'bold', padding: '32px'}}>
                  Só é possível submeter o formulário após preencher todos os campos obrigatórios.
                  <p>Campos em falta: <span style={{color: 'rgb(255, 200, 21)'}}>{this.emptyFields().join(', ')}</span></p>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <Modal show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>Contacte-nos</Modal.Title>
          </Modal.Header> */}

        {/* </Modal> */}
        {this.state.successVisible &&
        <Alert bsStyle="success" onDismiss={this.handleSuccessDismiss}>
          <p>O seu pedido de orçamento foi enviado com sucesso.</p>
        </Alert>
        }
        {this.state.errorVisible &&
        <Alert bsStyle="danger" onDismiss={this.handleErrorDismiss}>
          <p>Ocorreu um erro, por favor tente novamente.</p>
        </Alert>
        }
      </div>
    );
  }
}

ContactForm.displayName = 'ContactForm';

// Uncomment properties you need
// ContactForm.propTypes = {};
// ContactForm.defaultProps = {};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactFormComplete.js